import { routeList } from '@/router/helpers/routes'
import { validateRouteMandatoryProps } from '@/router/helpers/validations'

export default [{
	path: routeList.COMPANY_PAYMENTS_BASE_PATH,
	beforeEnter (to, from, next) {
		next(false)
	}
},
{
	path: routeList.COMPANY_PAYMENTS_REQUEST_TPA_PATH,
	name: routeList.COMPANY_PAYMENTS_REQUEST_TPA_NAME,
	props: true,
	component: () => import('@/views/companyPayments/requestTPA/TPAsList')
},
{
	path: routeList.COMPANY_PAYMENTS_REQUEST_TPA_BAI_PATH,
	name: routeList.COMPANY_PAYMENTS_REQUEST_TPA_BAI_NAME,
	props: true,
	component: () => import('@/views/companyPayments/requestTPA/BAI'),
	beforeEnter (to, from, next) {
		validateRouteMandatoryProps(to, from, next, routeList.COMPANY_PAYMENTS_REQUEST_TPA_NAME)
	}
}, {
	path: routeList.COMPANY_PAYMENTS_BAI_PAGA_MERCHANT_PATH,
	name: routeList.COMPANY_PAYMENTS_BAI_PAGA_MERCHANT_NAME,
	props: true,
	component: () => import('@/views/companyPayments/BaiPagaMerchant')
}, {
	path: routeList.COMPANY_PAYMENTS_TPA_REQUESTS_LIST_PATH,
	name: routeList.COMPANY_PAYMENTS_TPA_REQUESTS_LIST_NAME,
	component: () => import('@/views/companyPayments/TPARequestsList')
}]
